<template lang="pug">
	.podcasts--detail-view.flex-col.full-width
		.flex-row.wrap.space-medium
			.flex-col
				img.podcast-image(:src="record.ImageUrl")
			.flex-1.flex-col.podcast-data.space-large
				slot(name="actions-top")
				.flex-row.justify.align-center
					.podcast-name {{record.Name}}
					.right.flex-row.space.align-center
						slot(name='actions-right')
				.flex-col.space(v-if="record.Description")
					.font-small.upper.grey {{$tCaption('Description')}}
					.description {{record.Description}}
				.flex-row.space-large
					.flex-col.space
						.font-small.upper.grey {{$tCaption('Reach')}}
						.font-big {{formatNumber(record.Reach, 'fixedPoint')}}
					.flex-col.space
						.font-small.upper.grey {{$tCaption('CPM')}}
						.font-big {{formatNumber(record.RatePrice, 'currency', 2)}}
					.flex-col.space
						.font-small.upper.grey {{$tCaption('Cost')}}
						.font-big {{formatNumber(record.EstimatedCost, 'currency', 2)}}
					.flex-col.space(v-if="record.Url")
						.font-small.upper.grey {{$tCaption('Url')}}
						a.font-big(:href="record.Url", target="_blank") {{$Data.limitText(record.Url, 50)}}
				slot(name="actions-bottom")
</template>

<script>
	import Data from 'app-core/Data';

	export default {
		translationCategory: 'podcast.DetailView',
		name: 'podcasts--detail-view',
		mixins: [Data.mixin],
		props: ['record'],
		data() {
			return {
			};
		},
		mounted() {
			if (__DEBUG__)
				window.podcastDetails = this;
		},
		methods: {
		}
	};
</script>
<style lang='scss'>
	.podcasts--detail-view {
		padding: 10px;
		background: #fff;
		border-radius: 6px;

		.podcast-data {
			min-width: 300px;
		}

		.podcast-name {
			font-size: 32px;
			font-weight: 100;
		}

		.podcast-image {
			max-width: 30vw;
			height: auto;
			border-radius: 6px;
		}

		.img-holder {
			max-width: 480px;
			max-height: 320px;
			width: 480px;

			background-size: cover !important;
			background-position: center !important;
			border-radius: 4px;
		}
	}
</style>
